<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content>
  <ion-label class="title">{{ 'ACCOUNT.password.title2' | translate }}</ion-label>
  <p class="security-note">{{ 'ACCOUNT.password.note' | translate }}</p>
  <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
    <!-- Password -->
    <ion-item class="item-input item-interactive" mode="md">
      <ion-input
        label="{{ 'ACCOUNT.password.currentPass' | translate }}"
        labelPlacement="stacked"
        #passwordCurrent
        autocomplete="new-password"
        clear-on-edit="false"
        formControlName="passwordCurrent"
        [type]="currentPassVisible ? 'text' : 'password'"
      ></ion-input>
      <ion-icon
        [name]="currentPassVisible ? 'eye-off' : 'eye'"
        color="primary"
        slot="end"
        (click)="currentPassVisible = !currentPassVisible; passwordCurrent.setFocus()"
      ></ion-icon>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="hasError('passwordCurrent', 'required')">{{ 'ACCOUNT.password.error.needCurrentPass' | translate }}</span>
    </div>
    <!-- Password new -->
    <ion-item mode="md" class="item-input item-interactive ion-item__new-password">
      <ion-input
        #passwordNew
        label="{{ 'ACCOUNT.password.newPass' | translate }}"
        labelPlacement="stacked"
        autocomplete="new-password"
        formControlName="password"
        clear-on-edit="false"
        [type]="newPassVisible ? 'text' : 'password'"
        (ionChange)="newPassChange()"
      ></ion-input>
      <ion-icon
        [name]="newPassVisible ? 'eye-off' : 'eye'"
        color="primary"
        slot="end"
        (click)="newPassVisible = !newPassVisible; passwordNew.setFocus()"
      ></ion-icon>
    </ion-item>
    <ion-progress-bar [color]="progressbarColor" [value]="getScore()"></ion-progress-bar>
    <div class="ion-input__errors" [class.ion-input__errors--valid]="(passwordControl.valid || passwordControl.untouched) && !passwordInvalid">
      <ng-container *ngIf="passwordInvalid; else passwordScore">
        <ng-container *ngIf="!validatePasswordLength(passwordControl.value); else showHint">
          <span *ngIf="hasError('password', 'required')">{{ 'ACCOUNT.password.error.needPass' | translate }}</span>
          <span *ngIf="passwordControl.value.length && hasError('password', 'minlength')">
            {{ 'ACCOUNT.newPassword.tips.li1' | translate }}
          </span>
          <span *ngIf="hasError('password', 'maxlength')">{{ 'ACCOUNT.newPassword.hints.longPassword' | translate }}</span>
        </ng-container>

        <ng-template #showHint>
          <span *ngIf="!passwordNumbers">{{ 'ACCOUNT.newPassword.hints.oneDigit' | translate }}</span>

          <span *ngIf="!passwordUppercaseLetters && passwordNumbers">{{ 'ACCOUNT.newPassword.hints.upperLetter' | translate }}</span>

          <span *ngIf="!passwordLowercaseLetters && passwordNumbers && passwordUppercaseLetters">
            {{ 'ACCOUNT.newPassword.hints.lowerLetter' | translate }}
          </span>

          <span *ngIf="!passDontHaveIdenticalChars && passwordNumbers && passwordUppercaseLetters && passwordLowercaseLetters">
            {{ 'ACCOUNT.newPassword.hints.noIdentical' | translate }}
          </span>
        </ng-template>
      </ng-container>

      <ng-template #passwordScore>
        <span *ngIf="score <= 30 && passwordControl.value.length">
          {{ 'ACCOUNT.password.passIs' | translate }} {{ 'ACCOUNT.password.tooWeak' | translate }}.
        </span>
        <span *ngIf="score && score > 30 && score <= 60">{{ 'ACCOUNT.password.passIs' | translate }} {{ 'ACCOUNT.password.good' | translate }}.</span>
        <span *ngIf="score && score > 60 && score <= 80">
          {{ 'ACCOUNT.password.passIs' | translate }} {{ 'ACCOUNT.password.strong' | translate }}.
        </span>
        <span *ngIf="score && score > 80">{{ 'ACCOUNT.password.passIs' | translate }} {{ 'ACCOUNT.password.superStrong' | translate }}.</span>
      </ng-template>
    </div>
    <div class="password-tips">
      <p>{{ 'ACCOUNT.newPassword.tips.title' | translate }}</p>
      <ul>
        <li [class.check]="passwordControl.value.length >= minLength">
          <div class="password-tips__dot"></div>
          <ion-icon name="checkmark-outline"></ion-icon>
          {{ 'ACCOUNT.newPassword.tips.li1' | translate }}
        </li>
        <li [class.check]="passwordNumbers">
          <div class="password-tips__dot"></div>
          <ion-icon name="checkmark-outline"></ion-icon>
          {{ 'ACCOUNT.newPassword.tips.li2' | translate }}
        </li>
        <li [class.check]="passwordUppercaseLetters">
          <div class="password-tips__dot"></div>
          <ion-icon name="checkmark-outline"></ion-icon>
          {{ 'ACCOUNT.newPassword.tips.li3' | translate }}
        </li>
        <li [class.check]="passwordLowercaseLetters">
          <div class="password-tips__dot"></div>
          <ion-icon name="checkmark-outline"></ion-icon>
          {{ 'ACCOUNT.newPassword.tips.li4' | translate }}
        </li>
      </ul>
    </div>
    <!-- Password new confirm -->
    <ion-item class="item-input item-interactive" mode="md">
      <ion-input
        #passwordRepeat
        label="{{ 'ACCOUNT.password.repPass' | translate }}"
        labelPlacement="stacked"
        autocomplete="new-password"
        (keyup.enter)="changePassword()"
        [type]="repeatPassVisible ? 'text' : 'password'"
        clear-on-edit="false"
        formControlName="passwordConfirmation"
      ></ion-input>
      <ion-icon
        [name]="repeatPassVisible ? 'eye-off' : 'eye'"
        color="primary"
        slot="end"
        (click)="repeatPassVisible = !repeatPassVisible; passwordRepeat.setFocus()"
      ></ion-icon>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="hasError('passwordConfirmation', 'required')">{{ 'ACCOUNT.password.error.needConfPass' | translate }}</span>
      <span *ngIf="changePasswordForm.controls.passwordConfirmation.value.length && hasError('passwordConfirmation', 'minlength')">
        {{ 'ACCOUNT.newPassword.tips.li1' | translate }}
      </span>
    </div>
    <!-- Log in -->
    <ion-button type="submit" mode="ios" expand="block">{{ 'ACCOUNT.password.title' | translate }}</ion-button>
    <!-- Forgot password -->
    <ion-button mode="ios" color="light" expand="block" (click)="openForgotPassword()">
      {{ 'ACCOUNT.password.forgot' | translate }}
    </ion-button>
  </form>
</ion-content>
